import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { EmailEntryType } from '@econtractor/types';
import SolarIcon from 'components/icons/SolarIcon';
import { useEmailsDirectory } from './context/EmailsDirProvider';

const EmailEntryActions = ({ entry }: { entry: EmailEntryType }) => {
    const { t } = useTranslation('EmailsDir');
    const { busy, setEditing, remove } = useEmailsDirectory();
    return (
        <div className="d-flex justify-content-end gap-1">
            <Button type="button" className="p-1 py-0" size="sm" variant="light-secondary" disabled={busy} title={t('edit')} aria-label={t('edit')} onClick={() => setEditing(entry)}>
                <SolarIcon name="pencil" />
            </Button>
            <Button type="button" className="p-1 py-0" size="sm" variant="light-danger" disabled={busy} title={t('delete')} aria-label={t('delete')} onClick={() => remove(entry)}>
                <SolarIcon name="trash" />
            </Button>
        </div>
    );
};

export default EmailEntryActions;
